namespace Matrix.Data {
    export class JpmSecClassOverrideColumns {
        static columnsKey = 'Data.JpmSecClassOverride';
    }
}
